export default __webpack_public_path__ + "static/media/selecta_mobile_small@2x.1f351f09.jpg";